import { Notification } from '@thanx/uikit/notification'
import { Text } from '@thanx/uikit/text'
import { useStyletron } from 'baseui'
import LookerLabs from 'components/Icons/LookerLabs'
import { buildTranslate } from 'locales'
import { merchantTheme } from 'theme'

const t = buildTranslate('insights_lab.banner')

const InsightsLabBanner = () => {
  const [css] = useStyletron()

  return (
    <Notification
      overrides={{
        Body: {
          style: {
            width: '100%',
            backgroundColor: merchantTheme.colors.grey10,
          },
        },
        InnerContainer: {
          style: {
            width: '100%',
            color: merchantTheme.colors.grey90,
          },
        },
      }}
      kind="info"
      size="full"
    >
      <div
        data-testid="insights-lab-banner"
        className={css({
          display: 'grid',
          gridTemplateColumns: 'auto 1fr',
          gap: '8px',
          padding: '12px',
        })}
      >
        <LookerLabs
          className={css({
            margin: '2px 0',
            width: '10px',
            height: '10px',
          })}
        />
        <div
          className={css({
            display: 'grid',
            gap: '4px',
          })}
        >
          <Text.BodyText5 bold>{t('title')}</Text.BodyText5>
          <Text.BodyText4 color="grey70">{t('description')}</Text.BodyText4>
        </div>
      </div>
    </Notification>
  )
}

export default InsightsLabBanner
